var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFullLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 91,
    viewBox: "0 0 306 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.08 74C70.6107 74 70.2267 73.8507 69.928 73.552C69.6293 73.2533 69.48 72.8693 69.48 72.4V30.8C69.48 30.3307 69.6293 29.9467 69.928 29.648C70.2267 29.3493 70.6107 29.2 71.08 29.2H100.968C101.437 29.2 101.821 29.3493 102.12 29.648C102.419 29.9467 102.568 30.3307 102.568 30.8V36.816C102.568 37.2853 102.419 37.6693 102.12 37.968C101.821 38.2667 101.437 38.416 100.968 38.416H80.552V47.056H99.56C100.029 47.056 100.413 47.2267 100.712 47.568C101.011 47.8667 101.16 48.2507 101.16 48.72V54.288C101.16 54.7147 101.011 55.0987 100.712 55.44C100.413 55.7387 100.029 55.888 99.56 55.888H80.552V64.784H101.48C101.949 64.784 102.333 64.9333 102.632 65.232C102.931 65.5307 103.08 65.9147 103.08 66.384V72.4C103.08 72.8693 102.931 73.2533 102.632 73.552C102.333 73.8507 101.949 74 101.48 74H71.08ZM127.059 74.64C122.792 74.64 119.251 74.0427 116.435 72.848C113.619 71.6107 111.486 70.0107 110.035 68.048C108.584 66.0853 107.816 63.9947 107.731 61.776C107.731 61.4347 107.859 61.136 108.115 60.88C108.414 60.5813 108.755 60.432 109.139 60.432H117.203C117.8 60.432 118.248 60.5387 118.547 60.752C118.888 60.9653 119.187 61.2427 119.443 61.584C119.784 62.224 120.254 62.8427 120.851 63.44C121.491 64.0373 122.302 64.528 123.283 64.912C124.307 65.2533 125.566 65.424 127.059 65.424C129.534 65.424 131.39 65.04 132.627 64.272C133.907 63.504 134.547 62.4587 134.547 61.136C134.547 60.1973 134.206 59.4293 133.523 58.832C132.84 58.192 131.731 57.6373 130.195 57.168C128.702 56.656 126.696 56.144 124.179 55.632C120.936 54.9493 118.163 54.0747 115.859 53.008C113.598 51.8987 111.87 50.4693 110.675 48.72C109.48 46.928 108.883 44.7093 108.883 42.064C108.883 39.4613 109.608 37.136 111.059 35.088C112.552 33.04 114.622 31.44 117.267 30.288C119.912 29.136 123.048 28.56 126.675 28.56C129.619 28.56 132.2 28.944 134.419 29.712C136.68 30.48 138.579 31.504 140.115 32.784C141.651 34.064 142.803 35.4293 143.571 36.88C144.382 38.288 144.808 39.6747 144.851 41.04C144.851 41.3813 144.723 41.7013 144.467 42C144.211 42.256 143.891 42.384 143.507 42.384H135.059C134.59 42.384 134.184 42.2987 133.843 42.128C133.502 41.9573 133.203 41.68 132.947 41.296C132.691 40.3573 132.008 39.5467 130.899 38.864C129.832 38.1387 128.424 37.776 126.675 37.776C124.798 37.776 123.326 38.1173 122.259 38.8C121.235 39.44 120.723 40.4427 120.723 41.808C120.723 42.6613 121 43.408 121.555 44.048C122.152 44.688 123.112 45.2427 124.435 45.712C125.8 46.1813 127.656 46.672 130.003 47.184C133.886 47.9093 137.022 48.8267 139.411 49.936C141.8 51.0027 143.55 52.4107 144.659 54.16C145.768 55.8667 146.323 58.0213 146.323 60.624C146.323 63.5253 145.491 66.0427 143.827 68.176C142.206 70.2667 139.944 71.8667 137.043 72.976C134.142 74.0853 130.814 74.64 127.059 74.64Z",
    fill: "url(#paint0_linear_117_7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 51.554C61 68.8074 46.5822 77.5613 28.797 77.5613C11.0117 77.5613 12.1301 68.8074 12.1301 51.554C12.1301 34.3006 11.0117 25 28.797 25C46.5822 25 61 34.3006 61 51.554Z",
    fill: "url(#paint1_linear_117_7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6526 63.9602C25.094 63.9602 27.0732 63.9022 27.0732 66.2193C27.0732 68.5365 25.094 70.4149 22.6526 70.4149C20.2112 70.4149 18.2321 68.5365 18.2321 66.2193C18.2321 63.9022 20.2112 63.9602 22.6526 63.9602Z",
    fill: "url(#paint2_linear_117_7)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_117_7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 40.6763,
    width: 33.3516,
    height: 17.751,
    rx: 8.87548,
    fill: "url(#paint3_linear_117_7)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 40.6763,
    width: 33.3516,
    height: 17.751,
    rx: 8.87548,
    fill: "url(#paint4_linear_117_7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5136 49.667C15.5136 52.5954 15.5747 54.9693 13.1352 54.9693C10.6958 54.9693 8.7182 52.5954 8.7182 49.667C8.7182 46.7387 10.6958 44.3648 13.1352 44.3648C15.5747 44.3648 15.5136 46.7387 15.5136 49.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.936 74C164.467 74 164.083 73.8507 163.784 73.552C163.485 73.2533 163.336 72.8693 163.336 72.4V39.248H151.944C151.475 39.248 151.091 39.0987 150.792 38.8C150.493 38.4587 150.344 38.0747 150.344 37.648V30.8C150.344 30.3307 150.493 29.9467 150.792 29.648C151.091 29.3493 151.475 29.2 151.944 29.2H186.376C186.845 29.2 187.229 29.3493 187.528 29.648C187.827 29.9467 187.976 30.3307 187.976 30.8V37.648C187.976 38.0747 187.827 38.4587 187.528 38.8C187.229 39.0987 186.845 39.248 186.376 39.248H174.984V72.4C174.984 72.8693 174.835 73.2533 174.536 73.552C174.237 73.8507 173.853 74 173.384 74H164.936ZM195.393 74C194.923 74 194.539 73.8507 194.241 73.552C193.942 73.2533 193.793 72.8693 193.793 72.4V30.8C193.793 30.3307 193.942 29.9467 194.241 29.648C194.539 29.3493 194.923 29.2 195.393 29.2H225.281C225.75 29.2 226.134 29.3493 226.433 29.648C226.731 29.9467 226.881 30.3307 226.881 30.8V36.816C226.881 37.2853 226.731 37.6693 226.433 37.968C226.134 38.2667 225.75 38.416 225.281 38.416H204.865V47.056H223.873C224.342 47.056 224.726 47.2267 225.025 47.568C225.323 47.8667 225.472 48.2507 225.472 48.72V54.288C225.472 54.7147 225.323 55.0987 225.025 55.44C224.726 55.7387 224.342 55.888 223.873 55.888H204.865V64.784H225.793C226.262 64.784 226.646 64.9333 226.944 65.232C227.243 65.5307 227.393 65.9147 227.393 66.384V72.4C227.393 72.8693 227.243 73.2533 226.944 73.552C226.646 73.8507 226.262 74 225.793 74H195.393ZM236.268 74C235.798 74 235.414 73.8507 235.116 73.552C234.817 73.2533 234.668 72.8693 234.668 72.4V30.8C234.668 30.3307 234.817 29.9467 235.116 29.648C235.414 29.3493 235.798 29.2 236.268 29.2H253.676C259.18 29.2 263.51 30.48 266.668 33.04C269.868 35.5573 271.468 39.1413 271.468 43.792C271.468 46.8213 270.721 49.3813 269.228 51.472C267.777 53.5627 265.857 55.1413 263.468 56.208L272.3 71.952C272.428 72.208 272.492 72.4427 272.492 72.656C272.492 72.9973 272.342 73.3173 272.044 73.616C271.788 73.872 271.468 74 271.084 74H262.636C261.825 74 261.228 73.808 260.844 73.424C260.46 72.9973 260.182 72.6133 260.012 72.272L252.716 58.192H246.124V72.4C246.124 72.8693 245.974 73.2533 245.676 73.552C245.377 73.8507 244.993 74 244.524 74H236.268ZM246.124 49.168H253.548C255.553 49.168 257.046 48.6773 258.028 47.696C259.052 46.7147 259.564 45.3707 259.564 43.664C259.564 42 259.073 40.656 258.092 39.632C257.153 38.608 255.638 38.096 253.548 38.096H246.124V49.168Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.893 7.41333C276.604 5.88047 278.614 4.71832 280.796 4C281.42 4.78171 282.212 5.41271 283.113 5.84611C284.015 6.27951 285.002 6.50415 286.003 6.50333C287.003 6.50415 287.99 6.27951 288.892 5.84611C289.793 5.41271 290.585 4.78171 291.209 4C293.391 4.71832 295.401 5.88047 297.113 7.41333C296.748 8.34408 296.599 9.3449 296.674 10.3415C296.75 11.3381 297.049 12.3048 297.549 13.17C298.049 14.0368 298.737 14.7799 299.563 15.344C300.389 15.9082 301.332 16.2788 302.321 16.4283C302.788 18.6765 302.788 20.9968 302.321 23.245C300.388 23.5417 298.604 24.6783 297.549 26.5033C297.049 27.3687 296.749 28.3358 296.674 29.3327C296.598 30.3296 296.748 31.3307 297.113 32.2617C295.401 33.7939 293.391 34.9555 291.209 35.6733C290.585 34.8919 289.793 34.2612 288.891 33.8281C287.99 33.395 287.003 33.1707 286.003 33.1717C285.002 33.1709 284.015 33.3955 283.113 33.8289C282.212 34.2623 281.42 34.8933 280.796 35.675C278.614 34.9572 276.604 33.7956 274.893 32.2633C275.257 31.3324 275.407 30.3312 275.331 29.3343C275.256 28.3374 274.957 27.3704 274.456 26.505C273.956 25.6385 273.268 24.8957 272.442 24.3319C271.616 23.7681 270.673 23.3977 269.684 23.2483C269.216 20.9996 269.216 18.6787 269.684 16.43C270.673 16.2804 271.616 15.9098 272.442 15.3457C273.268 14.7816 273.957 14.0385 274.456 13.1717C274.956 12.3065 275.255 11.3397 275.331 10.3432C275.407 9.34656 275.257 8.34575 274.893 7.415V7.41333ZM288.503 24.1667C289.076 23.8408 289.579 23.4047 289.983 22.8835C290.387 22.3624 290.684 21.7665 290.857 21.1301C291.029 20.4938 291.075 19.8295 290.99 19.1756C290.905 18.5217 290.691 17.8911 290.361 17.32C290.032 16.749 289.592 16.2488 289.068 15.8482C288.545 15.4477 287.947 15.1547 287.309 14.9862C286.672 14.8176 286.007 14.7768 285.354 14.8662C284.701 14.9555 284.071 15.1732 283.503 15.5067C282.364 16.1744 281.535 17.2656 281.197 18.5421C280.86 19.8186 281.041 21.1767 281.701 22.3201C282.361 23.4636 283.447 24.2995 284.721 24.6454C285.995 24.9914 287.355 24.8193 288.503 24.1667V24.1667Z",
    fill: "url(#paint5_linear_117_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_117_7",
    x: -14,
    y: 25.6763,
    width: 73.3516,
    height: 57.751,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_117_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_117_7",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_117_7",
    x1: 69.096,
    y1: 21.4399,
    x2: 177.878,
    y2: 99.7389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_117_7",
    x1: 52.9035,
    y1: 12.2055,
    x2: 12.5637,
    y2: 59.1118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE0",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_117_7",
    x1: 18.2055,
    y1: 64.992,
    x2: 29.6922,
    y2: 70.5555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_117_7",
    x1: 7.15448,
    y1: 40.6763,
    x2: 40.0829,
    y2: 53.6604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_117_7",
    x1: 7.15448,
    y1: 40.6763,
    x2: 40.0829,
    y2: 53.6604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_117_7",
    x1: 286.002,
    y1: 4,
    x2: 286.002,
    y2: 35.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFE0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 286,
    height: 80,
    fill: "white",
    transform: "translate(0 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullLight);
export default __webpack_public_path__ + "static/media/logo-full-light.c3efd0bb1fe8e8323487f64a4ea43dfc.svg";
export { ForwardRef as ReactComponent };